/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { usePolicyId } from '../../provider';
import { apiConfig } from '@pages/ProvisionalDetailPage/config/api.config';
import { UPDATE_KYC_STATUS } from '@pages/ProvisionalDetailPage/api/graphql';

export interface IUpdateKYCStatusPluginMethods extends IPluginMethodMap {
  getUpdateKYCStatus(args?: any): Promise<any>;
}

export interface UpdateKycProps {
  comments: string;
  kyc_status: string;
}

export class UpdateKYCStatusPlugin implements IAgentPlugin {
  readonly methods: IUpdateKYCStatusPluginMethods;

  constructor() {
    this.methods = {
      getUpdateKYCStatus: this.getUpdateKYCStatus.bind(this),
    };
  }

  async getUpdateKYCStatus(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    return {
      //products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    const { userVid } = usePolicyId();
    let gql = Graphql.withBaseUrl(apiConfig.spacex_gql.url);
    // const token = getToken();
    const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .mutation(UPDATE_KYC_STATUS, {
            input: {
              vuid: userVid,
              comment: args?.comments ?? null,
              status: args?.kyc_status === 'approve' ? 'VERIFIED' : 'REJECTED',
              type: ['ID_PROOF', 'ADDRESS_PROOF'],
            },
          })
          .toPromise();
        console.info('KYC status', res);
        if (res?.data) {
          return res?.data?.updateKYCDocStatus?.message;
        }
      }
    } catch (err: any) {
      log.error('error in capsules=', err?.message);
      throw err;
    }
  }
}
